type ServiceId = string
class DisabledServices {
    [token: string]: {
        participant: {
            [travellerIndex: number]: ServiceId[]
        },
        accomodation: ServiceId[]
    }

}

export default DisabledServices